export default {"src":"/uk/_next/static/media/hsbc.a3c30b56.svg","height":85,"width":316,"blurWidth":0,"blurHeight":0};